// src/contexts/NotificationSocketProvider.jsx
import React, { createContext, useContext, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { getCurrentUser } from '../services/authService';

const NotificationContext = createContext();

export const useSocket = () => useContext(NotificationContext);

export const NotificationSocketProvider = ({ children }) => {
    const socketRef = useRef(null);

    useEffect(() => {
        const user = getCurrentUser();
        if (!user) return;

        const socket = io('https://book-lovers-4592.onrender.com', {
            auth: { token: user.token },
            transports: ['websocket'],
            secure: true,
          });

        socketRef.current = socket;
        window.socket = socket; // 💡 For console debugging

        socket.on('connect', () => {
            console.log("✅ Connected to socket server");
        });

        socket.on('connect_error', (err) => {
            console.error("❌ Socket connection error:", err.message);
        });

        return () => {
            socket.disconnect();
        };
    }, []);

    return (
        <NotificationContext.Provider value={socketRef}>
            {children}
        </NotificationContext.Provider>
    );

};
